import apiClient from './api';

const planService = {
    // `market` ('intl' | 'bd') sets the currency view for dual-market ('all') packages: the
    // same stored amount lists as $(amount/100) for 'intl' and ৳amount for 'bd'. No effect
    // on 'bangladesh' (always ৳) or 'others' (always $) packages.
    getPackages: async (market) => {
        const response = await apiClient.get('/api/plans', { params: { status: 'active', market } });
        return response.data; // each item has: id, credits, basePrice, finalPrice, discountPercent, defaultCoupon, packageType
    },

    validateCoupon: async ({ code, planId, market }) => {
        const response = await apiClient.post('/api/coupons/validate', { code, planId, market });
        return response.data; // { valid, code, discountPercent, finalPrice, saving }
    },
};

export default planService;
